import {normalizeVariationProperties} from './property-normalizer';

export function getPropertyValue(properties, propertyId, defaultValue) {
  return normalizeVariationProperties(properties, {
    selection: { [propertyId]: 1 },
    sortByPriority: false,
  })[0]?.value?.values?.value ?? defaultValue;
}
export default {
  methods: {
    getPropertyValue,
  },
};
